import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { HttpServices } from 'src/app/shared/services/http-service.service';
import { FeesEstimationAdminDto } from '../models/fees-estimation-admin.model';


@Injectable({ providedIn: 'root' })
export class FeesEstimationAdminService {

    constructor(private http: HttpServices) {
    }

    AddReviewerDecision(data: FeesEstimationAdminDto) {
        return this.http.post('FeesEstimation/AddReviewerDecision', data);
    }
    fillMeasurmentFees(data: FeesEstimationAdminDto) {
        return this.http.post('FeesEstimation/AddFeesAndDecision', data);
    }
    fillMarineFees(data: FeesEstimationAdminDto) {
        return this.http.post('FeesEstimation/MarineFees', data);
    }
    fillManagerFees (data: FeesEstimationAdminDto) {
        return this.http.post('FeesEstimation/ManagerFees', data);
    }
    fillManagerFeesNew (data: FeesEstimationAdminDto) {
        return this.http.post('FeesEstimation/ManagerFeesNew', data);
    }
}